import React from 'react';
import FlexRow from '../shared/FlexRow';
import { loadEventImage } from '../../utils/images';

export default function CategoryEvents({ events, removeEvent, rowNumber }) {
  const [clickedEvent, setClickedEvent] = React.useState(null);

  const handleRemoveEvent = (url) => {
    removeEvent(rowNumber, url);
  };
  return (
    <FlexRow justifyContent="flex-start" expand={styles.scroller}>
      <EventGenerator events={events} clickedEvent={clickedEvent}>
        {({ singleEvent, is_clicked }) => (
          <div style={is_clicked ? styles.clicked : styles.default} onClick={(e) => setClickedEvent(singleEvent.Url)}>
            {is_clicked && (
              <div style={styles.removeEvent} onClick={() => handleRemoveEvent(singleEvent.Url)}>
                <p style={styles.removeText}>x</p>
              </div>
            )}
            <p style={styles.center}>{singleEvent.Url}</p>
            <img style={styles.image} src={loadEventImage(singleEvent, 'coverImage')} />
            <p style={styles.center}>{singleEvent.Title}</p>
          </div>
        )}
      </EventGenerator>
    </FlexRow>
  );
}

const EventGenerator = ({ children, events, clickedEvent }) => {
  if (!events || events.length == 0) return [];
  return events.map((event) => {
    const is_clicked = event.Url == clickedEvent;
    return children({ singleEvent: event, is_clicked });
  });
};

const styles = {
  removeText: { fontSize: 20, margin: 0 },
  removeEvent: { position: 'absolute', top: 5, right: 10, cursor: 'pointer' },
  image: { width: 250, height: 250, borderRadius: 6 },
  scroller: { overflowX: 'auto', gap: 10, maxWidth: '90%', boxSizing: 'border-box', flexShrink: 0 },
  center: { textAlign: 'center' },
  default: { position: 'relative', borderRadius: 6 },
  clicked: { position: 'relative', border: '3px solid black' },
};
